export const TOPIC_RECOMMENDATION_API_ENDPOINT="/topics/";
export const STYLE_WRITING_API_ENDPOINT="/improvements/";
export const LOGIN_API_ENDPOINT="/token/" 
export const REGISTER_API_ENDPOINT="/register/"
export const LOGOUT_API_ENDPOINT="/logout/"
export const UPDATE_PASSWORD_API_ENDPOINT="/password/request-update/"
export const RAG_SUBMIT_QUERY_ENDPOINT="/rag/submit_prompt_query"
export const RAG_ANSWER_ENDPOINT="/rag/get_prompt_answer"
export const LIBRARY_SUBJECT_ENDPOINT = "/library/subjects/"
export const LIBRARY_RESOURCE_ENDPOINT = "/library/resources/"
export const DICTIONARY_VOCABULARY_ENDPOINT = "/vocabulary/"
export const USER_PROFILE_ENDPOINT = "/user/profile"
export const REVIEW_INSIGHTS_ENDPOINT = "/insights/"
export const REVIEW_VOCABULARY_ENDPOINT = "/review/"
export const DOCUMENT_SCANNER_ENDPOINT = "/scan"
export const SAVE_WORD_ENDPOINT = "/vocabulary/"
export const VOCABULARY_GENERATE_ENDPOINT = "/vocabulary/generate"
export const CHAT_SCENARIOS_GENERATE_ENDPOINT = "/scenarios/generate/"
export const CHAT_WARM_UP_ENDPOINT = "/chat/warm-up/"
export const CHAT_SESSIONS_ENDPOINT = "/chat-sessions/"
export const CHAT_SESSION_INSIGHTS_ENDPOINT = "/chat/sessions/"
export const CHAT_CONVERSATIONS_ENDPOINT = "/chat/conversations"
export const WORD_EXTRACTION_ENDPOINT = "/word/extraction/"
export const CHAT_SCENARIO_WS_BASE_URL = process.env.VUE_APP_CHAT_SCENARIO_WS_BASE_URL || "ws://localhost:8000/ws/chat/scenario/"
export const READING_ASSISTANCE_WS_URL = process.env.VUE_APP_READING_ASSISTANCE_WS_BASE_URL  || "ws://localhost:8000/ws/reading-assistance/"
export const VOICE_READER_WS_URL = process.env.VUE_APP_VOICE_READER_WS_BASE_URL || "ws://localhost:8000/ws/voice-reader/"
export const DOCUMENT_SUMMARIZE_ENDPOINT = "/documents/summarize/"
export const COMPREHENSION_QUESTIONS_ENDPOINT = "/documents/comprehension-questions/"
export const DOWNLOAD_PDF_API_ENDPOINT = "/download_pdf"
export const DOWNLOAD_PARSED_PDF_API_ENDPOINT = "/download_pdf/parsed"
export const DOWNLOAD_IMG_API_ENDPOINT = "/download_img"
export const DOWNLOAD_DOCX_API_ENDPOINT = "/download_docx"
export const LIBRARY_WEBSITE_SUGGESTION_ENDPOINT = "/library/website_suggestions/"
export const FEEDBACK_ENDPOINT = '/feedback/'
export const GENERATE_RESOURCES_ENDPOINT = '/documents/generate/'
export const BASE_URL = process.env.VUE_APP_BASE_URL || "http://localhost:8000/api"
export const WEB_SOCKET_URL = process.env.VUE_APP_WEB_SOCKET_URL || "ws://localhost:8000/ws/socket-server/"
export const RAG_BASE_URL= process.env.VUE_APP_RAG_BASE_URL || "http://localhost:8080"
export const SCANNER_BASE_URL= process.env.VUE_APP_SCANNER_BASE_URL || "http://localhost:3200"
